<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">

      <!-- Filters -->
      <md-card style="margin-bottom: 20px;">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>filter_list</md-icon>
          </div>
          <h4 class="title">Filter Registrations</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout md-gutter">

            <div class="md-layout-item md-size-40 md-small-size-100">
              <md-field>
                <label for="workshop-filter">Workshop</label>
                <md-select v-model="filters.workshopId" name="workshop-filter" @md-selected="applyFilters">
                  <md-option value="">All Workshops</md-option>
                  <md-option
                    v-for="w in workshops"
                    :key="w._id"
                    :value="w._id"
                  >
                    {{ w.title }} — {{ w.date }}
                  </md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-30 md-small-size-100">
              <md-field>
                <label for="status-filter">Payment Status</label>
                <md-select v-model="filters.status" name="status-filter" @md-selected="applyFilters">
                  <md-option value="">All Statuses</md-option>
                  <md-option value="pending">Pending</md-option>
                  <md-option value="paid">Paid</md-option>
                  <md-option value="failed">Failed</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-30 md-small-size-100" style="display:flex; align-items:center; padding-top: 10px;">
              <md-button class="md-success" @click="applyFilters">
                <md-icon>search</md-icon> Apply
              </md-button>
              <md-button class="md-default" @click="resetFilters" style="margin-left:8px;">
                <md-icon>clear</md-icon> Reset
              </md-button>
            </div>

          </div>
        </md-card-content>
      </md-card>

      <!-- Stats Row -->
      <div class="md-layout md-gutter" style="margin-bottom: 20px;">
        <div class="md-layout-item md-size-25 md-small-size-50">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon total"><md-icon>group</md-icon></div>
              <div class="stat-info">
                <span class="stat-number">{{ stats.total }}</span>
                <span class="stat-label">Total</span>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-25 md-small-size-50">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon paid"><md-icon>check_circle</md-icon></div>
              <div class="stat-info">
                <span class="stat-number">{{ stats.paid }}</span>
                <span class="stat-label">Paid</span>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-25 md-small-size-50">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon pending"><md-icon>schedule</md-icon></div>
              <div class="stat-info">
                <span class="stat-number">{{ stats.pending }}</span>
                <span class="stat-label">Pending</span>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-25 md-small-size-50">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon revenue"><md-icon>currency_rupee</md-icon></div>
              <div class="stat-info">
                <span class="stat-number">₹{{ stats.revenue }}</span>
                <span class="stat-label">Revenue</span>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <!-- Table -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Workshop Registrations</h4>
        </md-card-header>

        <md-card-content v-if="tableData.length === 0">
          <div style="text-align:center; padding: 40px 0; color: #aaa;">
            <md-icon style="font-size: 3rem !important;">inbox</md-icon>
            <h4>No registrations found.</h4>
          </div>
        </md-card-content>

        <md-card-content v-else>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="md-container-custom paginated-table"
            table-header-color="green"
            md-fixed-header
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >{{ item }}</md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">

              <md-table-cell md-label="Name" md-sort-by="name">
                <div class="name-cell">
                  <div class="avatar-circle">{{ getInitials(item.name) }}</div>
                  <div>
                    <strong>{{ item.name }}</strong> <small>({{ item.totalPerson }} {{ item.totalPerson === 1 ? 'Person' : 'People' }})</small>
                    <br>
                    <small style="color:#888;">{{ item.phoneNumber }}</small>
                  </div>
                </div>
              </md-table-cell>

              <md-table-cell md-label="Workshop">
                <span v-if="item.workshopDetail">
                  <strong>{{ item.workshopDetail.title }}</strong><br>
                  <small style="color:#888;">
                    <md-icon style="font-size:13px !important; vertical-align: middle;">event</md-icon>
                    {{ item.workshopDetail.date }}
                  </small>
                </span>
                <span v-else style="color:#aaa;">—</span>
              </md-table-cell>

              <md-table-cell md-label="Amount">
                <strong style="font-size:1rem;">
                  ₹{{ getAmount(item) }}
                </strong>
              </md-table-cell>

              <md-table-cell md-label="Payment Status" md-sort-by="paymentStatus">
                <span class="status-badge" :class="item.paymentStatus">
                  <md-icon style="font-size:14px !important; vertical-align:middle; margin-right:3px;">
                    {{ item.paymentStatus === 'paid' ? 'check_circle' : item.paymentStatus === 'failed' ? 'cancel' : 'schedule' }}
                  </md-icon>
                  {{ capitalize(item.paymentStatus) }}
                </span>
              </md-table-cell>

              <md-table-cell md-label="Razorpay Order ID">
                <small class="mono-text">{{ item.razorpayOrderId || '—' }}</small>
              </md-table-cell>

              <md-table-cell md-label="Registered On" md-sort-by="created_at">
                {{ HumanReadableDateFormat(item.created_at, true) }}
              </md-table-cell>

              <md-table-cell md-label="Notes">
                <span v-if="item.notes" style="color:#555; font-size:0.85rem;">{{ item.notes }}</span>
                <span v-else style="color:#ccc;">—</span>
              </md-table-cell>

            </md-table-row>
          </md-table>

          <md-card-actions md-alignment="space-between">
            <div>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </md-card-actions>
        </md-card-content>
      </md-card>

    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import WorkshopService from "../../../services/WorkshopService";

export default {
  name: "WorkshopRegistrationList",
  components: { Pagination },

  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) result = this.searchedData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) highBound = this.total;
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
    },
    stats() {
      const all = this.tableData;
      return {
        total:   all.length,
        paid:    all.filter(r => r.paymentStatus === 'paid').length,
        pending: all.filter(r => r.paymentStatus === 'pending').length,
        revenue: all
          .filter(r => r.paymentStatus === 'paid')
          .reduce((sum, r) => sum + this.getAmount(r), 0)
      };
    }
  },

  data() {
    return {
      tableData: [],
      workshops: [],
      searchedData: [],
      currentSort: "created_at",
      currentSortOrder: "desc",
      filters: {
        workshopId: "",
        status: ""
      },
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      }
    };
  },

  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        const aVal = a[sortBy] ?? "";
        const bVal = b[sortBy] ?? "";
        if (this.currentSortOrder === "desc") {
          return String(aVal).localeCompare(String(bVal));
        }
        return String(bVal).localeCompare(String(aVal));
      });
    },

    getWorkshops() {
      WorkshopService.getWorkshops()
        .then(res => { this.workshops = res.data.data; })
        .catch(e => { this.$toast.error(e.response?.data?.respones_msg || 'Failed to load workshops'); });
    },

    getRegistrations() {
      const params = {};
      if (this.filters.workshopId) params.workshopId = this.filters.workshopId;
      if (this.filters.status)     params.status     = this.filters.status;

      WorkshopService.getWorkshopRegistrations(params)
        .then(res => {
          this.tableData = res.data.data;
          this.pagination.currentPage = 1;
        })
        .catch(e => { this.$toast.error(e.response?.data?.response_msg || 'Failed to load registrations'); });
    },

    applyFilters() { this.getRegistrations(); },

    resetFilters() {
      this.filters = { workshopId: "", status: "" };
      this.getRegistrations();
    },

    getAmount(item) {
      if (!item.workshopDetail?.price) return 0;
      return parseInt(item.workshopDetail.price) * (item.totalPerson || 1);
    },

    getInitials(name) {
      if (!name) return '?';
      return name.trim().split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
    },

    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },

  beforeMount() {
    this.getWorkshops();
    this.getRegistrations();
  }
};
</script>

<style scoped>
/* Stats Cards */
.stat-card .md-card-content {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px !important;
}

.stat-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon .md-icon { color: white !important; font-size: 1.6rem !important; }
.stat-icon.total   { background: linear-gradient(135deg, #667eea, #764ba2); }
.stat-icon.paid    { background: linear-gradient(135deg, #48bb78, #38a169); }
.stat-icon.pending { background: linear-gradient(135deg, #ed8936, #c05621); }
.stat-icon.revenue { background: linear-gradient(135deg, #76acaf, #62989b); }

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 1.6rem;
  font-weight: 700;
  color: #2d3748;
  line-height: 1;
}

.stat-label {
  font-size: 0.8rem;
  color: #a0aec0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 4px;
}

/* Name cell */
.name-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #76acaf, #62989b);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
}

/* Status badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.status-badge.paid    { background: rgba(72,187,120,0.15); color: #276749; }
.status-badge.pending { background: rgba(237,137,54,0.15);  color: #c05621; }
.status-badge.failed  { background: rgba(245,101,101,0.15); color: #c53030; }

/* Persons chip */
.chip-persons {
  background: rgba(118,172,175,0.15) !important;
  color: #2c7a7b !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
}

/* Monospace text for IDs */
.mono-text {
  font-family: 'Courier New', monospace;
  font-size: 0.78rem;
  color: #718096;
  word-break: break-all;
}
</style>